export default __webpack_public_path__ + "static/media/dia5.0e12cf32.png";